import { render } from "./setting.vue?vue&type=template&id=641c46df&ts=true"
import script from "./setting.component.ts?vue&type=script&lang=ts"
export * from "./setting.component.ts?vue&type=script&lang=ts"

import exportComponent from "/Volumes/ExDisk/Cong viec/LuvTransitltms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__